module.exports = __webpack_public_path__ + "static/media/india-avenue.d56eee9e.csv";